export default {
  Customers: 'Customers',
}
